import { affiliateMerchants } from "../settings/affiliate";
import namedRoutes from "../settings/routes";

// signalWire: 1 = Included, 2 = Capable, 4 = Not Supported/Unknown

export default {
  "Anker Solix": [
    {
      name: "Alternator Charger",
      manual:
        "https://salesforce-knowledge-download.s3.us-west-2.amazonaws.com/000030947/en_US/000030947.pdf",
      //link: "https://www.ankersolix.com/products/alternator-charger",
      amazon: {
        href: "https://www.amazon.com/dp/B0GQ2PFNQ5/",
        affiliate: "https://amzn.to/4ozOT0y",
      },
      img: "/images/products/anker/anker-alternator-charger.webp",
      price: 369,
      signalWire: 4,
      alternator: 800,
      solar: 0,
    },
  ],
  BLUETTI: [
    {
      name: "Charger 2",
      review: namedRoutes.bluetti.charger2.review,
      manual:
        "https://cdn.shopify.com/s/files/1/0550/5620/3836/files/charger-2-user-manual.pdf?v=1767706542",
      link: {
        href: "https://www.bluettipower.com/products/bluetti-charger-2-alternator-solar-charger",
        affiliateData: affiliateMerchants.bluetti,
        icon: "Bluetti",
      },
      amazon: {
        href: "https://www.amazon.com/dp/B0FS7C11QG/",
        affiliate: "https://amzn.to/4tLpbHI",
      },
      img: "/images/products/bluetti/charger-2/front.webp",
      price: 449,
      signalWire: 2,
      alternator: 800,
      solar: 600,
      captions: {
        alternator:
          "BLUETTI Charger 2 combined alternator & solar output is 1200W maximum.",
      },
    },
    {
      name: "Charger 1",
      review: namedRoutes.bluetti.charger1.compatibility,
      manual:
        "https://s4.bluettipower.com/bluetti_lgf/support/2025/05/4a4f1b84-aa5a-4563-8e3f-28f5c3053576.pdf",
      link: {
        href: "https://www.bluettipower.com/products/bluetti-charger-1",
        affiliateData: affiliateMerchants.bluetti,
        icon: "Bluetti",
      },
      amazon: {
        href: "https://www.amazon.com/dp/B0DGXYPMQ4/",
        affiliate: "https://amzn.to/4msoVLk",
      },
      img: "/images/products/bluetti/charger-1/front.webp",
      price: 249,
      signalWire: 4,
      alternator: 560,
      solar: 0,
    },
  ],
  BougeRV: [
    {
      name: "DC600 Alternator Charger",
      manual:
        "https://cdn.shopify.com/s/files/1/2672/9544/files/DC600_-_20250910.pdf?v=1762759056",
      amazon: {
        href: "https://www.amazon.com/dp/B0FS6STSWS/",
        affiliate: "https://amzn.to/4tyvgHN",
      },
      img: "/images/products/bougerv/dc600-alternator-charger/front.webp",
      price: 109,
      signalWire: 4,
      alternator: 600,
      solar: 0,
    },
  ],
  "DJI Power": [
    {
      name: "1kW Super Fast Car Charger",
      manual:
        "https://dl.djicdn.com/downloads/DJI_Power_Accessories/DJI_Power_1kW_Super_Fast_Car_Charger_Multi.pdf",
      //link: "https://store.dji.com/product/dji-power-1kw-super-fast-car-charger",
      amazon: {
        href: "https://www.amazon.com/dp/B0DMTGHNPR",
        affiliate: "https://amzn.to/44XGJ9R",
      },
      img: "/images/products/dji/1kw-super-fast.webp",
      price: 299,
      signalWire: 4,
      alternator: 1000,
      solar: 0,
    },
    {
      name: "1.8kW Solar/Car Super Fast Charger",
      manual:
        "https://dl.djicdn.com/downloads/DJI_Power_Accessories/DJI_Power_1.8kW_SolarCar_Super_Fast_Charger_Multi04.pdf",
      link: {
        href: "https://store.dji.com/product/dji-power-1800w-solar-super-fast-car-charger",
      },
      img: "/images/products/dji/1_8kw-solar-car-super-fast.webp",
      price: 319,
      signalWire: 4,
      alternator: 600,
      solar: 1200,
    },
  ],
  EcoFlow: [
    {
      name: "Alternator Charger Plus 1000",
      description: "(select markets)",
      review: namedRoutes.ecoflow.altCharger.gen2,
      manual:
        "https://manuals.ecoflow.com/us/product/alternator-charger-plus-1000",
      link: {
        href: "https://eu.ecoflow.com/products/1000w-alternator-charger?variant=48080282714455",
        affiliateData: affiliateMerchants.ecoflow,
        icon: "EcoFlow",
      },
      img: "/images/products/ecoflow/alternator-charger-plus-1000/front.webp",
      price: "€329,00",
      signalWire: 1,
      alternator: 1000,
      solar: 300,
      captions: {
        alternator:
          "EcoFlow Alternator Charger Plus 1000 can output maximum 1000W from alternator or 1000W combined alternator and solar.",
      },
    },
    {
      name: "Alternator Charger 600",
      description: "(select markets)",
      review: namedRoutes.ecoflow.altCharger.gen2,
      manual: "https://manuals.ecoflow.com/us/product/alternator-charger-600",
      link: {
        href: "https://eu.ecoflow.com/products/600w-alternator-charger?variant=50705288986967",
        affiliateData: affiliateMerchants.ecoflow,
        icon: "EcoFlow",
      },
      img: "/images/products/ecoflow/alternator-charger-600/front.webp",
      price: "€249,00",
      signalWire: 1,
      alternator: 600,
      solar: 0,
    },
    {
      name: "800W Alternator Charger",
      review: namedRoutes.ecoflow.altCharger.review,
      manual: "https://manuals.ecoflow.com/us/product/alternator-charger-800w",
      link: {
        href: "https://us.ecoflow.com/products/800w-alternator-charger",
        affiliateData: affiliateMerchants.ecoflow,
        icon: "EcoFlow",
      },
      amazon: {
        href: "https://www.amazon.com/dp/B0DSBZVPS6/",
        affiliate: "https://amzn.to/3N4b6p1",
      },
      img: "/images/products/ecoflow/alternator-charger-800w/front-right.webp",
      price: 259,
      signalWire: 4,
      alternator: 800,
      solar: 0,
    },
    {
      name: "500W Alternator Charger",
      review: namedRoutes.ecoflow.altCharger.review,
      manual: "https://manuals.ecoflow.com/eu/product/alternator-charger-500w",
      link: {
        href: "https://us.ecoflow.com/products/ecoflow-500w-alternator-charger",
        affiliateData: affiliateMerchants.ecoflow,
        icon: "EcoFlow",
      },
      amazon: {
        href: "https://www.amazon.com/dp/B0FYCJ6KD3/",
        affiliate: "https://amzn.to/4jzlwsP",
      },
      img: "/images/products/ecoflow/alternator-charger-500w/front.webp",
      price: 199,
      signalWire: 4,
      alternator: 500,
      solar: 0,
    },
  ],
  ETaker: [
    {
      name: "F2000 DC to DC MPPT Charger",
      manual:
        "https://cdn.shopify.com/s/files/1/0770/3455/3528/files/ETaker_F2000_Alternator_Charger_User_Manual_V0_2024.11.pdf?v=1732590731",
      amazon: {
        href: "https://www.amazon.com/dp/B0F3P2BTBL/",
        affiliate: "https://amzn.to/3YxbUF8",
      },
      img: "/images/products/etaker/f2000.webp",
      price: 259,
      signalWire: 2,
      alternator: 800,
      solar: 1000,
      captions: {
        alternator:
          "ETaker F2000 alternator output increases to 1000W when connected to a 24V system.",
      },
    },
  ],
  "Goal Zero": [
    {
      name: "YetiLink Vehicle Integration Kit V3",
      description: "(only works with Goal Zero)",
      manual:
        "https://cdn.shopify.com/s/files/1/0520/1156/5225/files/2021-10_Link_UserGuide_TR_CL100621V1_WEB.pdf?v=1657914799",
      link: {
        href: "https://goalzero.com/products/yeti-link-vehicle-integration-kit-v3",
      },
      img: "/images/products/goal-zero/yetilink-v3.webp",
      price: 338,
      signalWire: 4,
      alternator: 750,
      solar: 0,
    },
  ],
  Jackery: [
    {
      name: "DC-DC Alternator Charger",
      manual:
        "https://r.jackery.net/productGuide/Jackery%20DC-DC%20Charger%20User%20Manual.pdf",
      link: {
        href: "https://www.jackery.com/products/jackery-dc-dc-alternator-charger",
        affiliateData: affiliateMerchants.jackery,
        icon: "Jackery",
      },
      amazon: {
        href: "https://www.amazon.com/dp/B0FVDSYYX7",
        affiliate: "https://amzn.to/45J9ZBn",
      },
      img: "/images/products/jackery/jackery-dc-dc-alternator-charger.webp",
      price: 269,
      signalWire: 1,
      alternator: 600,
      solar: 0,
    },
  ],
  OUPES: [
    {
      name: "800W Alternator Charger",
      manual:
        "https://cdn.shopify.com/s/files/1/0599/0137/8737/files/OUPES_800W_Alternator_Charger_User_Manual.pdf?v=1764734024",
      amazon: {
        href: "https://www.amazon.com/dp/B0GD64Y495/",
        affiliate: "https://amzn.to/3NRmnd0",
      },
      img: "/images/products/oupes/800w-alternator-charger/front-right.webp",
      price: 299,
      signalWire: 4,
      alternator: 800,
      solar: 0,
    },
  ],
  Pecron: [
    {
      name: "DC1242-500 Car Charger",
      manual:
        "https://cdn.shopify.com/s/files/1/0509/5263/4556/files/PECRON_DC1242-500_-20231117_1.pdf?v=1709618500",
      //link: "https://www.pecron.com/products/pecron-500w-car-charger-dc1242-500-for-car-rv-van",
      amazon: {
        href: "https://www.amazon.com/dp/B0DZXG536D",
        affiliate: "https://amzn.to/4juPjD5",
      },
      img: "/images/products/pecron/500w-car-charger.webp",
      price: 149,
      signalWire: 4,
      alternator: 500,
      solar: 0,
    },
  ],
};
